import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const DEFAULT_TTL = 5 * 60 * 1000;
const store = new Map(); // key -> { at, data, promise }

/** Cache mémoire partagé : une seule requête pour les données communes à plusieurs blocs. */
export function getCached(key, path, { ttl = DEFAULT_TTL } = {}) {
  const hit = store.get(key);
  const now = Date.now();
  if (hit?.promise) return hit.promise;
  if (hit && now - hit.at < ttl) return Promise.resolve(hit.data);

  const promise = axios
    .get(`${API}${path}`)
    .then((r) => {
      const data = r.data;
      store.set(key, { at: Date.now(), data });
      return data;
    })
    .catch((e) => {
      store.delete(key);
      throw e;
    });
  store.set(key, { ...(hit || {}), promise });
  return promise;
}

export function invalidate(key) {
  if (key) store.delete(key);
  else store.clear();
}

export const fetchTarifs = () => getCached("tarifs", "/tarifs");
export const fetchRealisations = (scope = "home") =>
  getCached(`realisations:${scope}`, `/realisations?scope=${scope}`);
